import { Alert, AlertTitle, AlertDescription, AlertAction, Button } from '@monksflow/monks-ui';
import { Check } from 'lucide-react';
import { useAnalysisNotificationStore } from '../../model/analysisNotificationStore';
import { useTranslation } from 'react-i18next';

export function AnalysisNotifications() {
  const { t } = useTranslation('analysis');

  const initiatedCount = useAnalysisNotificationStore((s) => s.initiatedCount);
  const completedAnalyses = useAnalysisNotificationStore((s) => s.completedAnalyses);
  const dismissInitiated = useAnalysisNotificationStore((s) => s.dismissInitiated);
  const dismissCompleted = useAnalysisNotificationStore((s) => s.dismissCompleted);

  if (initiatedCount === 0 && completedAnalyses.length === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 z-50 flex w-[400px] -translate-x-1/2 flex-col gap-2">
      {initiatedCount > 0 && (
        <Alert
          variant="default"
          icon={<Check className="size-4" />}
          className="border-0 bg-surface shadow-md"
        >
          <AlertTitle>{t('analysis.analysisNotifications.analysisGenerationStarted')}</AlertTitle>
          <AlertDescription>{t('analysis.analysisNotifications.thisMayTakeUpTo')}</AlertDescription>
          <AlertAction>
            <Button variant="outline" size="sm" className="bg-white" onClick={dismissInitiated}>
              {t('analysis.analysisNotifications.dismiss')}
            </Button>
          </AlertAction>
        </Alert>
      )}
      {completedAnalyses.map((analysis) => (
        <Alert
          key={analysis.id}
          variant="default"
          icon={<Check className="size-4" />}
          className="border-0 bg-surface shadow-md"
        >
          <AlertTitle>{t('analysis.analysisNotifications.analysisComplete')}</AlertTitle>
          <AlertDescription>
            {t('analysis.analysisNotifications.readyToView', { analysisName: analysis.name })}
          </AlertDescription>
          <AlertAction>
            <Button
              variant="outline"
              size="sm"
              className="bg-white"
              onClick={() => dismissCompleted(analysis.id)}
            >
              {t('analysis.analysisNotifications.dismiss')}
            </Button>
          </AlertAction>
        </Alert>
      ))}
    </div>
  );
}
